<template>
    <div ref="page" class="page" :style="dialogShow?'overflow:hidden':''">
        <div class="page-head space-between align-center" :style="wexin?'height:0;transform:translate(0,-100px)':''">
            <img @click="back()" class="svg-icon" src="../assets/img/return.svg"/>
            <div style="flex: 1;color:white;text-align: left;font-size: 18px;margin-left: 10px">{{dialogTitle}}
            </div>
            <img @click="dialogShow =true;showMap()" style="margin-right: 10px" class="svg-icon"
                 src="../assets/img/position.svg"/>
            <img @click="jumpTo('/')" style="margin-right: 10px"
                 class="svg-icon"
                 src="../assets/img/home.svg"/>
        </div>
        <div class="page-content" :style="wexin?'top:0px':''">
            <router-view/>
        </div>
        <div class="dialog-mask text-center" v-show="dialogShow" @touchmove="stopPropagation">
            <div class="dialog">
                <div class="dialog-titile vertical-center">
                    <img style="width:18px;" src="../assets/img/position.svg"/>
                    <div style="color:#fff;font-size: 14px;margin-left: 6px">诊所地址</div>
                </div>
                <div id="map_container" class="border-layout-bottom" style="top:40px"></div>
            </div>
            <div class="dialog-close">
                <img @click="dialogShow=false" src="../assets/img/close.svg"/>
            </div>
        </div>

        <div class="fixed-icon vertical-center">

            <!--<div v-if="wexin" class="phone-icon" style="margin-right: 10px">-->
                <!--<img @click="dialogShow =true;showMap()" class="svg-icon"-->
                     <!--style="width: 30px;height:30px;margin-left: 1px"-->
                     <!--src="../assets/img/position.svg"/>-->
            <!--</div>-->
            <!--<div v-if="wexin" class="phone-icon" style="margin-right: 10px;">-->
                <!--<img @click="jumpTo('/')"-->
                     <!--class="svg-icon"-->
                     <!--style="width: 30px;height:30px;margin-left: 1px"-->
                     <!--src="../assets/img/home.svg"/>-->
            <!--</div>-->

            <!--<div class="phone-icon" :data-phone="res.phone" @click="location.href='tel://'+res.phone">-->
                <!--<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="svg-icon fa-svg-icon svg-fa-call"-->
                     <!--width="32" height="32" viewBox="0 0 24 24">-->
                    <!--<path d="M6.62 10.79a15.15 15.15 0 0 0 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"></path>-->
                <!--</svg>-->
            <!--</div>-->
        </div>
    </div>
</template>

<script>
    import api from "../api";
    import utils from "../common/utils";
    import {Indicator, Toast,MessageBox} from 'mint-ui';

    export default {
        name: "home",
        data() {
            return {
                authed: false,
                location: location,
                appid: "",
                code: "",
                openId: '',
                dialogShow: false,
                dialogTitle: "首页",
                height: 0,
                wexin: true,
                YY_USER_ID: "",
                res: {
                    phone: ""
                }
            }
        },
        methods: {
            stopPropagation: function (e) {
                e.stopPropagation();
            },
            back: function () {
                history.go(-1);
            },
            showMap: function () {
                var map = new BMap.Map("map_container");
//                var point = new BMap.Point(116.404, 39.915);
//                map.centerAndZoom(point, 15);
                map.enableScrollWheelZoom(true);
                var res = this.intro;

                var latlng = res.loc.split(",");

                var point = new BMap.Point(latlng[0], latlng[1]);

                var opts = {
                    position: point,    // 指定文本标注所在的地理位置
                    offset: new BMap.Size(-40, -50)    //设置文本偏移量
                }
                var label = new BMap.Label(res.locName, opts);  // 创建文本标注对象
                label.setStyle({
                    color: "#555",
                    fontSize: "12px",
                    height: "20px",
                    lineHeight: "20px",
                    padding: "10px",
                    fontFamily: "微软雅黑",
                    borderColor: "#666;"
                });
                map.addOverlay(label);
                setTimeout(() => {
                    map.centerAndZoom(point, 17);
                }, 300)

            },
            isWeixin: function () {
                let wx = navigator.userAgent.toLowerCase()
                if (wx.match(/MicroMessenger/i) == 'micromessenger') {
                    return true
                } else {
                    return false
                }
            },
            jumpTo: function (path) {
                this.$router.push({
                    path: path,
                    query: {
                        YY_USER_ID: this.$route.query.YY_USER_ID,
                        openId: this.$route.query.openId || this.openId
                    }
                })
            },
            auth: function () {
                Indicator.open('加载中...');
                const scope = 'snsapi_userinfo'; // snsapi_base|snsapi_userinfo
                api.getFormUrl(this, "/yy/front/getWxAppid", null, (res) => {
                    Indicator.close();
                    this.appid = res.appId;
                    this.appidAgent = res.componetAppId;
                    var url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + this.appid 
                            + "&redirect_uri=" + encodeURIComponent(window.location.href) 
                            + `&response_type=code&scope=${scope}&state=STATE&component_appid=` + this.appidAgent + "#wechat_redirect";
                    // alert(url)
                    window.location.href = url;
                }, (err) => {
                    Indicator.close();
                    Toast({
                        message: err.rspDesc,
                        position: 'bottom',
                        duration: 5000
                    });
                });
            },
            reloadPageAddOpenId:function (){
                this.$router.push({
                    path: this.$route.path,
                    query:Object.assign({
                        openId:this.openId
                    },this.$route.query)
                })
            },
            loadBaseInfo:function (){
                api.getFormUrl(this, "yy/front/getBaseInfo?YY_USER_ID=" + this.$route.query.YY_USER_ID, null, (res) => {
                    this.intro = res;
                    this.res.phone = res.phone;
                    // res.clientID = 111;
                    this.$store.state.baseInfo = res;
                    Indicator.close();
                    this.loadBindInfo();
                }, (err) => {
                    Toast({
                        message: err.rspDesc,
                        position: 'bottom',
                        duration: 5000
                    });
                    Indicator.close();
                });
            },
            loadBindInfo: function (callback) {
                var _this = this;
                var url = "http://wx.kq123.com:10123/QSYYAjaxServer/PBClientTest?guid=" + this.$store.state.baseInfo.clientID + "&sql=is>" + this.$route.query.openId;
                Indicator.open('加载中...');

                api.corsGet(url, (res) => {
                    Indicator.close();
                    if (res != "not find client") {
                        if (res == "") {
                            _this.hasBind = false;
                            _this.bindNo = "";
                            MessageBox({
                                title: '提示',
                                closeOnClickModal:false,
                                message: '尚未绑定患者，请前往绑定?',
                                confirmButtonText: "前往绑定"
                            }).then(() => {
                                this.$router.push({
                                    path: "/bindPatient",
                                    query: {
                                        YY_USER_ID: this.$route.query.YY_USER_ID,
                                        openId: this.$route.query.openId
                                    }
                                })
                            }).catch(() => {
                                // this.chargeInfo = "请先绑定患者用户"
                            });
                        } else {
                            _this.hasBind = true;
                            _this.bindNo = res;
                            callback && callback();
                        }
                    }else{
                        Toast("未查询到对应的诊所信息");
                    }
                }, (err) => {
                    Toast("网络出错，请稍后再试");
                    Indicator.close();
                })
            },
        },
        created() {
            this.code = utils.getUrlParam2("code");
            this.authed = !!this.code;

            if (!this.authed) {   //没有微信授权时
                this.auth();
            } else {
                if (!this.$route.query.openId) {
                    this.appid = utils.getUrlParam2("appid");
                    api.getFormUrl(this, "/yy/front/getOpenIdByCode?appId=" + this.appid + "&code=" + this.code, null, (res) => {
                        // alert(JSON.stringify(res))
                        console.log(res);
                        this.openId = res.openId;
                        this.reloadPageAddOpenId();
                        this.loadBaseInfo();
                    }, (err) => {
                        Toast({
                            message: "获取openid失败" + err.rspDesc,
                            position: 'bottom',
                            duration: 5000
                        });
                        Indicator.close();
                    });
                }else{
                    this.loadBaseInfo();
                }
            }
        },
        mounted() {
            let _this = this;
//            this.wexin = this.isWeixin();
            this.dialogTitle = this.$router.currentRoute.name;
            this.height = this.$refs.page.height;
            setTimeout(() => {
                _this.$refs.page.style.opacity = 1;
            }, 50);

//            document.getElementsByTagName("title")[0].innerText = this.dialogTitle;
        }
    }
</script>

<style>
    .dialog-mask {
        background: rgba(0, 0, 0, .5);
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 20;
    }

    .dialog {
        width: 300px;
        height: 300px;
        background: white;
        border-radius: 5px;
        display: block;
        margin: auto;
        margin-top: 110px;
        position: relative;
    }

    .dialog-close {
        margin-top: 10px;
        display: block !important;
    }

    .dialog-titile {
        background: rgb(65, 160, 242);
        height: 40px;
        text-align: left;
        padding: 10px;
        box-sizing: border-box;
    }

    .BMapLabel {
        height: 30px !important;
        line-height: 30px !important;
        text-align: center;
        font-weight: bold !important;
        width: 60px !important;
        border: none !important;
        padding: 4px 15px 4px 15px !important;
        box-shadow: 2px 2px 18px rgba(0, 0, 0, .4);
        position: relative;
    }

    .BMapLabel:before {
        content: "";
        display: block;
        width: 1px;
        height: 1px;
        border-top: 5px solid #fff;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-bottom: 5px solid transparent;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        bottom: -10px;
    }

    .home-fixed {
        margin-top: 10px;
        animation: slide 0.3s ease;
    }

    .home-fixed > div {
        display: inline-block;
        padding: 10px;
        border-radius: 100px;
        box-shadow: 0 0 6px rgba(0, 0, 0, .1);
        background: rgba(65, 160, 242, 0.6);
        margin-right: 10px;
    }

    .home-fixed > div img {
        width: 20px;
        height: 20px;
    }

    .fixed-icon {
        position: fixed;
        right: 20px;
        bottom: 20px;
        z-index: 1000;
    }

    @-webkit-keyframes slide {
        0% {
            transform: translateY(-50px);
        }
        100% {
            transform: translateY(0);
        }
    }

    @-o-keyframes slide {
        0% {
            transform: translateY(-50px);
        }
        100% {
            transform: translateY(0);
        }
    }

    @-moz-keyframes slide {
        0% {
            transform: translateY(-50px);
        }
        100% {
            transform: translateY(0);
        }
    }

    @keyframes slide {
        0% {
            transform: translateY(-50px);
        }
        100% {
            transform: translateY(0);
        }
    }
</style>
